import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';

import endpoints from '@endpoints';
import { Tenant } from '@models/tenant';
import { ApiService } from '@services/api/api.service';
import { SimpleResponse } from '@models/api.model';
import { TenantSummary } from '@models/tenant/summary';
import { interpolate } from '@helpers/index';
import { TenantDataService } from '@services/data/tenant-data.service';

@Injectable({
    providedIn: 'root',
})
export class TenantService {
    private readonly _path = 'v1';

    private readonly api = inject(ApiService);
    private readonly tenantDataService = inject(TenantDataService);

    getTenants(): Observable<Tenant[]> {
        return this.api.get(this._path + endpoints.tenants).pipe(
            map((response: SimpleResponse<Tenant[]>) => {
                this.tenantDataService.updateTenants(response.data);
                return response.data;
            }),
            catchError(() => of([])),
        );
    }

    getTenantSummary(id: number): Observable<TenantSummary | null> {
        return this.api
            .get(this._path + interpolate(endpoints.tenantSummary, { id }))
            .pipe(
                map((response: SimpleResponse<TenantSummary>) => response.data),
                catchError(() => of(null)),
            );
    }

    getMineTenant() {
        return this.api.get(this._path + endpoints.tenantMine).pipe(
            map((response: SimpleResponse<Tenant>) => {
                if (response.data) {
                    this.tenantDataService.updateCurrentTenant(response.data);
                }
            }),
            catchError(() => {
                this.tenantDataService.updateCurrentTenant(null);
                return of(null);
            }),
        );
    }
}
